module.exports = __webpack_public_path__ + "static/media/PDF_73.4cda5e5a.pdf";